import { Injectable, ApplicationRef } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { CustomRequestService } from '../../../services/custom-request/custom-request.service';
import { LzUserMessagesService } from '../../lz-user-messages/services/lz-user-messages.service';
import { DomService } from "../../../services/dom-service/dom-service.service";

import { MessageHtmlComponent } from '../components/message-html/message-html.component';
import { MessageComponent } from '../components/message/message.component';
import { AccessMessageComponent } from "../components/access-message/access-message.component";

declare var $: any;

@Injectable()

export class LzMessageService {

  //options for HTML modal message
  private messageHtmlDialogOptions: any = {
    panelClass: 'lz-user-message-modal',
    disableClose: 'true',
    autoFocus: false,
    data: {}
  };
  private messageHtmlDialogRef: MatDialogRef < MessageHtmlComponent > ;

  //options for access modal message
  private accessMessageDialogOptions: any = {
    autoFocus: false,
    panelClass: 'lz-acess-message-modal',
    data: {}
  };
  private accessMessageDialogRef: MatDialogRef < AccessMessageComponent > ;

  //Object that contains componentRefs for all opened push-messages
  private pushMessagesRefs: Object = {};

  constructor(private http: HttpClient,
    private customRequestService: CustomRequestService,
    private dialog: MatDialog,
    private lzUserMessagesService: LzUserMessagesService,
    private domService: DomService,
    private appRef: ApplicationRef) {}

  //set HTML modal message as viewed after it was closed
  private markDialogOnClose = (options: any) => {
    let parameters: any;
    this.lzUserMessagesService.markAsLooked(options.unid, options);
  }

  //open HTML modal message
  openMessageHtmlDialog = (content: string, options ? : any, callback ? : any) => {
    $('.cdk-overlay-container').css('pointer-events', 'auto');
    this.dialog.closeAll();
    this.messageHtmlDialogOptions.data.content = content;
    this.messageHtmlDialogOptions.data.options = options;
    this.messageHtmlDialogOptions.data.callback = (callback) ? callback : undefined;
    this.messageHtmlDialogRef = this.dialog.open(MessageHtmlComponent, this.messageHtmlDialogOptions);
    this.messageHtmlDialogRef.afterClosed().subscribe(isClosedByUser => {
      if (isClosedByUser && !options.isViewed) {
        this.markDialogOnClose(options);
      }
      setTimeout(function () {
        $('.cdk-overlay-container').css('pointer-events', 'none');
      }, 500);
    });
    return this.messageHtmlDialogRef;
  }

  //open access modal message
  openAccessMessageDialog = (alias ? , isReg ? , prodLending ? , isProductText ? , productId ? , buyLink ? , testLink ? , realAlias ? ) => {
    this.dialog.closeAll();
    this.accessMessageDialogOptions.data.alias = alias;
    this.accessMessageDialogOptions.data.isReg = isReg;
    this.accessMessageDialogOptions.data.prodLending = prodLending;
    this.accessMessageDialogOptions.data.isProductText = isProductText;
    this.accessMessageDialogOptions.data.productId = productId;
    this.accessMessageDialogOptions.data.buyLink = buyLink;
    this.accessMessageDialogOptions.data.testLink = testLink;
    this.accessMessageDialogOptions.data.realAlias = realAlias;
    this.accessMessageDialogRef = this.dialog.open(AccessMessageComponent, this.accessMessageDialogOptions);
  }

  //open simple(error) message
  openMessage = (text: string) => {
    this.domService.appendComponentToBody(MessageComponent, false, {
      'text': text
    });
  }

  sendCommand = data => {
    return this.customRequestService.postRequestWithFormData(
      'lzservice/userSettings/sendCommand',
      data,
      false, {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    ).subscribe(() => {});
  };

  getTextAboutModule(id) {
    return this.customRequestService.getRequest('lzviewservice/document/' + id);
  };

  findConfigurations(alias, checkConfiguration) {
    return this.customRequestService.getRequest('lzservice/userData/findConfigurations', {
      alias: alias,
      checkConfiguration: checkConfiguration
    });
  };

  closeMessage = (data: any) => {
    try {
      let options = JSON.parse(data.data);
      if (options.contentType == 'HTML') {
        this.lzUserMessagesService.updateUserMessagesCount();
        this.dialog.closeAll();
      } else if (options.contentType == 'TEXT') {
        this.lzUserMessagesService.updateUserMessagesCount();
        if (options.unid) {
          this.appRef.detachView(this.pushMessagesRefs[options.unid].hostView);
          this.pushMessagesRefs[options.unid].destroy();
          delete this.pushMessagesRefs[options.unid];
        } else {
          if (options.id) {
            this.appRef.detachView(this.pushMessagesRefs[options.id].hostView);
            this.pushMessagesRefs[options.id].destroy();
            delete this.pushMessagesRefs[options.id];
          }
        }
      }
    } catch (error) {
      console.log("Error while closing message");
    }
  }

  sendPushMessage = (params: any, callback ? : any) => {
    let data = {
      "message": {
        "text": params.text || "",
        "from": params.from || "",
        "url": params.url || "",
        "priority": params.priority || "",
        "isMailoutNeeded": params.isMailoutNeeded || "",
        "contentType": params.contentType || "",
        "type": params.type || "",
        "topic": params.topic || "",
        "notificationTransports": params.notificationTransports || ""
      },
      "legalIds": params.legalIds || ""
    };

    this.customRequestService.postRequest('pushnotification/notification/push', data).subscribe(function (msg) {
      if (callback) {
        callback(msg);
      }
    });
  }

}
